import { InvoiceTaxBase } from "../../invoicing/abstract/invoice-tax-base.model";


export class PurchaseInvoiceTax extends InvoiceTaxBase {

    static override CLASS_NAME: string = 'PurchaseInvoiceTax';

}
